import { useEffect } from "react";
import WOW from "wow.js";

function useWOW() {
    useEffect(() => {
        const wow = new WOW({
            boxClass: "wow", // default
            animateClass: "animated", // default
            offset: 0, // default
            mobile: true, // default
            live: true, // default
        });
        wow.init();
    }, []);
}

export default useWOW;
